import TagManager from 'react-gtm-module';
const InitializeGoogleTagManager = (userEmail) => {
  TagManager.dataLayer({
    dataLayer: {
      userEmail,
      userProject: 'user account creation',
      event: 'user_created'
    },
  });
};
export default InitializeGoogleTagManager;
